import { DomainModelSerialCollection, ModelTypeDecorator } from '@nts/std';
import { DashBoardItem } from './dash-board-item';
import { DashBoardItemIdentity } from './dash-board-item.identity';

@ModelTypeDecorator(DashBoardItem)
export class DashBoardItemCollection extends DomainModelSerialCollection<DashBoardItem, DashBoardItemIdentity> {
    public serialPropertyName = 'itemId';
}
